/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function EnumSetting(props) {
  const { name, setting, handleSettingModified } = props;
  const [val, setVal] = React.useState(setting.Value);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setVal(typeof value === "string" ? value.split(",") : value);
    handleSettingModified(name, value);
  };
  return (
    <div>
      {name !== "Resolution" && (
        <FormControl
          fullWidth
          sx={{ mb: 1 }}
          disabled={setting.AllowedValues.length === 1}
        >
          <Typography gutterBottom>{name}</Typography>
          <Select
            defaultValue={setting.Value}
            onChange={handleChange}
            value={val}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>Select {name}</em>;
              }
              return (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected}
                </Box>
              );
            }}
          >
            <MenuItem disabled value=''>
              <em>Select {name}</em>
            </MenuItem>
            {setting.AllowedValues.map((value, index) => (
              <MenuItem value={value} key={index}>
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {name === "Resolution" && (
        <FormControl
          fullWidth
          sx={{ mb: 1 }}
          disabled={setting.AllowedValues.length === 1}
        >
          <Typography gutterBottom>{name}</Typography>
          <Select
            defaultValue={setting.Value}
            onChange={handleChange}
            value={val}
            renderValue={(selected) => {
              if (selected == null) {
                return <em>Select {name}</em>;
              }
              return (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.Width}x{selected.Height}
                </Box>
              );
            }}
          >
            <MenuItem disabled value=''>
              <em>Select {name}</em>
            </MenuItem>
            {setting.AllowedValues.map((value, index) => (
              <MenuItem value={value} key={index}>
                {value.Width}x{value.Height}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </div>
  );
}

EnumSetting.propTypes = {
  name: PropTypes.string.isRequired,
  setting: PropTypes.shape({
    AllowedValues: PropTypes.arrayOf(PropTypes.any).isRequired,
    Value: PropTypes.any.isRequired,
  }).isRequired,
  handleSettingModified: PropTypes.func.isRequired,
};
